export default "https://cdn-static.gokick.com/assets/b4422e726e3b42ca3d48f0d34192932f5b3fbcfa/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";